import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const JamforOfferter = lazy(() => import("@/pages/info/JamforOfferter"));

export const Route = createFileRoute("/offerter/")({
  head: () => seoHead("/offerter", { description: "Välj tjänst och få kostnadsfria offerter från upp till fyra kvalitetssäkrade leverantörer. Du fyller i dina förutsättningar en gång – vi matchar dig med rätt installatörer." }),
  component: () => <JamforOfferter />,
});
